// extracted by mini-css-extract-plugin
module.exports = {"main":"_2nQkPF _1rH5Jn","logo":"_1fFxi7 _3qX0zy","box-shadow":"_2LjAPh _1mUdNz"};